const truthyValues = new Set(['1', 'true', 'yes', 'on'])

const perfLoggingEnabled = truthyValues.has(
  String(process.env.REACT_APP_ENABLE_PERF_LOGS || '')
    .trim()
    .toLowerCase()
)

export const createPerfLogger = (label, metadata = {}) => {
  const startedAt = performance.now()
  let lastMark = startedAt

  const log = (stage, extra = {}) => {
    if (!perfLoggingEnabled || typeof console === 'undefined') {
      return
    }

    const current = performance.now()
    console.info('[perf]', {
      label,
      stage,
      elapsedMs: Number((current - startedAt).toFixed(2)),
      deltaMs: Number((current - lastMark).toFixed(2)),
      ...metadata,
      ...extra,
    })
    lastMark = current
  }

  return {
    mark: log,
    finish: extra => log('finish', extra),
  }
}

export const preloadImage = src => {
  if (!src || typeof Image === 'undefined') {
    return
  }

  const image = new Image()
  image.src = src
}
